export default "__VITE_ASSET__DqNPBOxc__"